// src/components/PersonalisedSkeleton.tsx
import React from 'react';
import HeroSection from './HeroSection';

const shimmer =
  'relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent';

const PersonalisedSkeleton: React.FC = () => {
  return (
    <>
      <section id="personalised-pricing-skeleton">
        <div className="bg-gray-50 min-h-screen flex flex-col items-center py-12 px-[25px] pt-[104px] md:pt-[146px]">
          {/* Header */}
          <HeroSection
            studentDetails={{
              first_name: ''
            }}
          />

          {/* Coach Note Card */}
          <div className="mt-10 max-w-[940px] w-full bg-[#FBF7FF] border border-gray-200 rounded-xl p-6 space-y-5">
            <div className={`h-4 w-40 bg-gray-200 rounded ${shimmer}`} />
            <div className="space-y-2">
              <div className={`h-3 w-full bg-gray-200 rounded ${shimmer}`} />
              <div className={`h-3 w-5/6 bg-gray-200 rounded ${shimmer}`} />
              <div className={`h-3 w-2/3 bg-gray-200 rounded ${shimmer}`} />
            </div>
            <div className="flex items-center gap-3">
              <div className={`h-10 w-10 bg-gray-300 rounded-full ${shimmer}`} />
              <div className={`h-4 w-24 bg-gray-200 rounded ${shimmer}`} />
            </div>
            <div className="border-t pt-4 flex items-center gap-3">
              <div className="flex -space-x-2">
                {[0, 1, 2].map((_, index) => (
                  <div
                    key={index}
                    className={`h-8 w-8 bg-gray-300 rounded-full border ${shimmer}`}
                  />
                ))}
              </div>
              <div className={`h-3 w-2/3 bg-gray-200 rounded ${shimmer}`} />
            </div>
          </div>

          {/* Lifestyle & Goals Section */}
          <div className="mt-10 max-w-[940px] grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
            <div className="bg-white rounded-xl border p-6 shadow-sm space-y-5">
              <div className={`h-10 w-10 bg-gray-300 rounded-full ${shimmer}`} />
              <div className={`h-5 w-32 bg-gray-200 rounded ${shimmer}`} />
              <div className="h-[1px] bg-[#EEE5DD]" />
              {[0, 1, 2].map((_, index) => (
                <div key={index} className="flex gap-[10px]">
                  <div className={`h-5 w-5 bg-gray-200 rounded-full border ${shimmer}`} />
                  <div className={`h-5 w-full bg-gray-200 rounded ${shimmer}`} />
                </div>
              ))}
            </div>
            <div className="bg-[#FFF8F2] rounded-xl border border-[#F1DFD0] p-6 shadow-sm space-y-5">
              <div className={`h-10 w-10 bg-gray-300 rounded-full ${shimmer}`} />
              <div className={`h-5 w-32 bg-gray-200 rounded ${shimmer}`} />
              <div className="h-[1px] bg-[#EEE5DD]" />
              {[0, 1, 2].map((_, index) => (
                <div key={index} className="flex gap-[10px]">
                  <div className={`h-5 w-5 bg-gray-200 rounded-full border ${shimmer}`} />
                  <div className={`h-5 w-full bg-gray-200 rounded ${shimmer}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Custom shimmer keyframes */}
          <style>{`
            @keyframes shimmer {
              100% {
                transform: translateX(100%);
              }
            }
          `}</style>
        </div>
      </section>
    </>
  );
};

export default PersonalisedSkeleton;
